import React from 'react'

function DummyAd() {
  return (
    <div style={{padding: '10px', border: 'solid 1px grey', color: 'grey', minHeight: '90px', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
      <div>
        Ads do not work on local/staging due to limitations from google ads.
      </div>
      <div>
        This block will be replaced by your ad tags on production.
      </div>
    </div>
  )
}

export default DummyAd
